import { render, staticRenderFns } from "./contentVideo.vue?vue&type=template&id=2efa29b0&scoped=true&"
import script from "./contentVideo.vue?vue&type=script&lang=js&"
export * from "./contentVideo.vue?vue&type=script&lang=js&"
import style0 from "./contentVideo.vue?vue&type=style&index=0&id=2efa29b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa29b0",
  null
  
)

export default component.exports